import {createTheme, ThemeProvider} from "@mui/material/styles";
import { Stack, Box, Typography, Icon, Chip, Card, CardMedia, CardContent, Button } from '@mui/material';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import { InfoIcon, LogoutOutlined, AccountCircle, ArrowBack } from '@mui/icons-material';
import axios from "axios";
import { AuthContext } from '../index';
import getLPTheme from '../getLPTheme';
import {useContext, useEffect, useState, useRef} from 'react';



import { BSERVICES } from '../data/database';
import getImage from '../utils/getImage';
import ItemsList from './ItemsList';
import Chat from './Chat';
import App from './App';


const ChatScreen = () => {
    const [view, setView] = useState('account');
    const [servicesStatus, setServicesStatus] = useState('active')
    const [servicePicked, setServicePicked] = useState(null);
    const { onLogout, id, phoneNumber } = useContext(AuthContext);

    const [services, setServices] = useState({
        isLoaded: false, data: []
    })

    const fillById = (id, arr = []) => {
        const ix = arr.findIndex(it => it.id == id);
        if (ix != -1) {
            return arr[ix];
        }

        return { id };
    }

    // const fillServices = (services = [], serviceTemplates = [], allLocations = []) => {
    //     return services.map(s => ({
    //         ...s,
    //         serviceTemplate: fillById(s.serviceTemplate.id, serviceTemplates),
    //         location: fillById(s.location.id, allLocations)
    //     }))
    // };

    const fillByParentId = (groupedLogs = [], services = []) => {
        return groupedLogs.map(it => ({
            ...it,
            service: fillById(it.parentId, services)
        }))
    }


    const groupLogs = (logs) => {
        return logs.reduce((acc, curr) => {
           const idx = acc.findIndex(it => it.parentId === curr.parentId && it.logType === curr.logType);

           if (idx != -1) {
               acc[idx].logs.push(curr);
           } else {
               acc.push({
                   parentId: curr.parentId,
                   logType: curr.logType,
                   logs: [curr]
               })
           }

           return acc;
        }, [])
    }


    const [ logs, setLogs ] = useState({
        isLoaded: false, data: []
    })

    async function loadLogs() {
        // const [ serviceTemplates, allLocations ] = await Promise.all([loadServiceTemplates(), loadAllLocations()]);

        let url = `/api/v1/logs/get`;
        let groupedLogs = [];

        try {
            const resp = await axios.post(url, {});
            groupedLogs = groupLogs(resp.data);

        } catch (err) { throw err; }

        try {
            const resp = await axios.post(`/api/v1/services/get`, {
                userIds: [id],
                ids: groupedLogs.filter(it => it.logType === 'service_message').map(it => it.parentId)
            });
        } catch (err) { throw err; }

        setLogs({isLoaded: true, data:[...fillByParentId(groupedLogs) ]});
    }

    useEffect(() => {
        loadLogs();
    },[])

    const handleAddLog = (parentId, userId, message, callback) => {
        try {
            const resp = axios.post(`/api/v1/logs`, {
                logType: 'service_message',
                message: message,
                parentId: parentId,
                userId: id
            })

        } catch (err) { throw err; }

        callback();
    }

    const handleServicePick = (service) => {
        setServicePicked(service);
        setView('detailed');
    }


    const getServices = (status) => {
        if (status == 'active') {
            return services.data.filter(s => {
                return s;
                // return s.logs.indexOf(log => log.message == 'CANCELLED') == -1
            });
        }


        if (status == 'notactive') {
            return services.data;
            // return services.data.filter(s => s.logs.indexOf(log => log.message == 'CANCELLED') != -1);
        }

        return [];
    }

    const getView = () => {
        let element = null;

        if (view == 'account') {
            element = (
                <Box
                    sx={{
                        backgroundColor: 'rgb(0 0 0/0.05)'
                    }}
                >
                    <Box sx={{
                        borderRadius: '20px',
                        backgroundColor: 'rgb(255 255 255)',
                        mb: '10px',
                        pb: '5px'
                    }}>
                        <Box sx={{pt: 10 }}>
                            <AccountCircle sx={{fontSize: '100px', color: 'rgb(0 0 0/0.15)'}}/>
                        </Box>
                        <Box sx={{p: 2 }}>
                            <Typography align={'center'} sx={{fontWeight: 'bold', fontSize: '20px'}}>Имя Фамилия</Typography>
                        </Box>
                        <Box>
                            <Typography sx={{fontSize: '14px', color: 'rgb(0 0 0/0.75)', mb: 1}} align={'center'}>{ phoneNumber }</Typography>
                        </Box>
                    </Box>
                    <Box sx={{
                        borderRadius: '20px',
                        backgroundColor: 'rgb(255 255 255)',
                        pt: '10px'
                    }}>
                        <Stack direction={'row'}  alignItems={'center'}
                               sx={{
                                   pt: 1,
                                   pr: 2,
                                   pl: 1
                               }}
                               onClick={() => { setView('visits'); }}
                        >
                            <BusinessCenterIcon sx={{p: 2, color: 'rgb(0 0 0/0.75)'}} />
                            <Typography fontSize={'18px'} sx={{color: 'rgb(0 0 0/ 0.7)'}} >Мои визиты</Typography>
                        </Stack>
                        <Stack direction={'row'}  alignItems={'center'}
                               sx={{
                                   pt: 1,
                                   pr: 2,
                                   pl: 1
                               }}
                               onClick={ onLogout }
                        >
                            <LogoutOutlined sx={{p: 2, color: 'rgb(0 0 0/0.75)'}} />
                            <Typography fontSize={'18px'} sx={{color: 'rgb(0 0 0/ 0.7)'}} >Выйти</Typography>
                        </Stack>
                    </Box>
                </Box>
            );
        } else if (view == 'visits') {
            element = (
                    <Box
                        sx={{
                            position: 'relative'
                        }}
                    >
                        <Box
                            sx={{
                                width: '100%',
                                position: 'fixed',
                                top: 0,
                                backgroundColor: "#fff",
                                // display: { xs: 'flex', sm: 'none'},
                                zIndex: 1301 // greate than swipable drawer 1300
                            }}
                        >

                        <Icon
                            onClick={() => { setView('account')}}
                            sx={{
                                '&:hover': { cursor: 'pointer', backgroundColor: "#000", color: "#fff"},
                                p: "3px",
                                backgroundColor: "#eee",
                                borderRadius: '8px',
                                position: 'fixed', top: '40px', left: '25px'}}
                        >
                            <ArrowBack/>
                        </Icon>
                        <Stack
                            sx={{
                                pt: '100px',
                                pl: '10px',
                                pr: '20px',
                                pb: '10px',
                            }}
                            direction={'row'}
                            spacing={1}
                        >
                            <Chip
                                sx={{ fontSize: '16px',
                                    backgroundColor: servicesStatus == 'active' ? '#aaa' : '',
                                }}
                                size={'large'}
                                label={ 'Активные' }
                                onClick={() => { setServicesStatus('active')}}>
                            </Chip>
                            <Chip
                                sx={{ fontSize: '16px',
                                    backgroundColor: servicesStatus == 'notactive' ? '#aaa' : '',
                            }}
                                size={'large'}
                                label={ 'Прошедшие' }
                                onClick={() => { setServicesStatus('notactive')}}>
                            </Chip>
                        </Stack>
                        </Box>
                            <ItemsList
                                sx={{
                                    m: 1
                                }}
                                items={ ["hello"] }
                                pickedItem={ servicePicked }
                                handleItemPick={ setServicePicked }
                                getItemId={ (item) => item?.id }
                                getItemTitle={ (item) => item?.serviceTemplate?.title }
                                getItemDescription={ (item) => item?.serviceTemplate.description }
                                getItemImages={ (item) => {
                                   return getImage(item?.serviceTemplate?.images?.map(im => im.id))
                                }}
                                getDetailedComponent={(item) => (
                                    <Stack>
                                        <Typography sx={{pt: 2}} align={'left'}>Детали массажа</Typography>
                                        <Typography sx={{pt: 2}} align={'left'}>{`Место: ${item?.location?.title}, ${item?.location?.address}`}</Typography>
                                        <Typography sx={{pt: 2}} align={'left'}>Дата и время: {item?.timeFrame?.from}</Typography>

                                        {/*<Chat*/}
                                        {/*    messages={ item?.logs?.map(log => ({id: log.id, text: log.message})) }*/}
                                        {/*    addMessage={(message) => { item?.logs?.push(message) }}*/}
                                        {/*/>*/}

                                        <Button sx={{mt:4}} variant={'contained'}>Отменить</Button>
                                    </Stack>
                                )}
                                getShortComponent={(item) => {

                                }}
                            />
                    </Box>
            );
        } else if (view == 'detailed') {
            element = (
                <Box
                    sx={{
                        position: 'relative'
                    }}
                >
                    <Icon
                        onClick={() => { setView('account')}}
                        sx={{
                            '&:hover': { cursor: 'pointer', backgroundColor: "#000", color: "#fff"},
                            p: "3px",
                            backgroundColor: "#eee",
                            borderRadius: '8px',
                            position: 'fixed', top: '40px', left: '25px'}}
                    >
                        <ArrowBack/>
                    </Icon>
                    <Stack
                        sx={{
                            pt: '100px',
                            pl: '20px',
                            pr: '20px'

                        }}
                        direction={'row'}
                    >
                        <Chip
                            sx={{ fontSize: '16px'}}
                            size={'large'}
                            label={ 'Активные' }
                            onClick={() => {}}>
                        </Chip>
                        <Chip
                            sx={{ fontSize: '16px'}}
                            size={'large'}
                            label={ 'Прошедшие' }
                            onClick={() => {}}>
                        </Chip>
                    </Stack>
                    <Stack sx={{pt:2}}>
                        {
                            services.data.map(service => (
                                <Card
                                    elevation={1}
                                    sx={{display: 'flex', m: 1}}
                                    onBlur={() => {}}
                                    onClick={() => {}}
                                >
                                    <Box
                                        sx={{position: 'relative'}}
                                    >
                                        <CardMedia
                                            sx={{ width: 100, height: 100, p: 1, borderRadius: '15px'}}
                                            component="img"
                                            image={service?.serviceTemplate?.images}
                                            alt=""
                                        />
                                    </Box>
                                    <CardContent
                                    >
                                        <Typography align='left' sx={{pb: 2, fontSize: '18px'}}>
                                            {service?.serviceTemplate?.title}
                                        </Typography>

                                    </CardContent>
                                </Card>
                            ))
                        }
                    </Stack>
                </Box>
            )
        }


        return element;
    }

    const [ itemDetailedPassed, setItemDetailedPassed ] = useState(null);

    return (
        <App
            withNavigation
        >
            <Stack spacing={3} direction='row'
                   sx={{
                       position: 'fixed',
                       top: 0,
                       left: 0,
                       right: 0,
                       zIndex: 1000,
                       p: 2,
                       alignItems: 'center',
                       backgroundColor: '#fcfcfc',
                       display: 'flex',
                       flexGrow: 0,
                       justifyContent: 'center',
                       boxShadow: 'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px'
                   }}
            >
                <Typography>Чаты</Typography>
            </Stack>
            <ItemsList
                sx={{ mt: '85px'}}
                items={ logs?.data ?? [] }
                pickedItem={ null }
                handleItemPick={ () => {} }
                itemDetailedPassed={ itemDetailedPassed }
                getItemId={ (item) => item?.parentId }
                getItemTitle={ (item) => 'Чат по поводу сервиса' }
                getItemDescription={ (item) => (
                    <div></div>
                    // <Stack>
                    //     <Typography align={'left'}>{item?.address}</Typography>
                    //     <Typography align={'left'}>{item?.description}</Typography>
                    //     { JSON.stringify(item) }
                    // </Stack>
                )}
                getItemImages={ (item) => {
                    return getImage(item?.images?.map(im => im.id))
                }}
                getDetailedComponent={(item) => (
                    <div>
                        <Chat
                            messages={ item?.logs?.map(log => ({id: log.id, text: log.message})) }
                            addMessage={(message) => {
                                handleAddLog(item.parentId, id, message, loadLogs);
                                // setItemDetailedPassed(logs.data.filter( it => it.parentId == item.parentId)[0])
                            }}
                        />
                    </div>
                )}
                getShortComponent={(item) => (
                    // <Grid item size={4}>
                    //     {
                    //         item?.timeFrames.map(tf => (
                    //             <Chip
                    //                 size={'small'}
                    //                 label={ DateTime.fromISO(tf.from, { zone: 'utc'}).toFormat("HH:mm") }
                    //                 onClick={(event) =>{
                    //                     event.stopPropagation();
                    //                     handleLocationTimeClick(tf.from, item);
                    //                 }}
                    //             >
                    //             </Chip>
                    //         ))
                    //     }
                    // </Grid>
                    <div></div>
                )
                }
            />
            {/*{ getView() }*/}
        </App>
    );
}

export default ChatScreen;
